import React, { Component } from 'react'
import { avatarFromString, colorForString } from '../../utils/usercolor'
import { TextArea, Loader, Icon } from 'semantic-ui-react'
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton'

// Modern
import ModernMessage from '../messages/modern/Message'
import ModernGenericAction from '../messages/modern/GenericAction'

// Pro
import ProMessage from '../messages/pro/Message'
import ProGenericAction from '../messages/pro/GenericAction'

import { initFirebase } from '../../apis/firebase'
import shortenURL from '../../apis/bitly'

import './messages.scss'

export default class GenericActionView extends Component {
  constructor() {
    super()

    this.state = { isUploading: false }
    this.colorCache = {}
    this.firebase = window.firebase || initFirebase()

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (this.props.messageList != prevProps.messageList) {
    setTimeout(
      function() {
        this.scrollToBottom()
      }.bind(this),
      10,
    )
    // }
  }

  render() {
    return (
      <div className="chat-section">
        <div className="chat-messages-section" id={`scrollable-chat-container-${this.props.target}`}>
          <div className="chat-messages-box">{this.messages()}</div>
        </div>
        <div className="chat-input-container">
          <CustomUploadButton
            accept="image/*"
            storageRef={this.firebase.storage().ref(this.props.client.nickname)}
            onUploadStart={this.handleUploadStart}
            onUploadError={this.handleUploadError}
            onUploadSuccess={this.handleUploadSuccess}
            onProgress={this.handleProgress}
            style={{ backgroundColor: 'steelblue', color: 'white', padding: 7, borderRadius: 4, textAlign: 'center' }}
          >
            {this.state.isUploading ? (
              <Loader active inline inverted size="tiny" style={{ top: '-5px', left: '-2px', position: 'relative' }} />
            ) : (
              <Icon name="cloud upload" size="large" />
            )}
            <br />
            {this.state.isUploading ? 'Wait...' : 'Upload'}
          </CustomUploadButton>
          <TextArea
            className="chat-section-input"
            autoHeight
            placeholder={this.props.connecting ? 'Connecting...' : 'Message...'}
            value={this.state.inputText}
            onChange={this.handleInputChange}
            onKeyPress={this.handleKeyPress}
          />
        </div>
      </div>
    )
  }

  handleInputChange(event) {
    const text = this.normalizeText(event.target.value)
    this.setState({
      inputText: text,
    })

    this.setState({ inputText: text })
  }

  handleKeyPress(event) {
    if (!this.state.inputText || this.state.inputText.length < 1) {
      return
    }

    if (event.key !== 'Enter') {
      return
    }

    if (this.props.connecting) {
      alert("We're still connecting you to #TheCabin.  Please wait...")
      return
    }

    const text = this.normalizeText(this.state.inputText)
    this.props.send(text, this.props.target)

    setTimeout(
      function() {
        this.setState({ inputText: '' })
      }.bind(this),
      20,
    )
  }

  messages() {
    return this.props.messageList.map(
      function(item, index) {
        return this.viewForItem(item, index)
      }.bind(this),
    )
  }

  viewForItem(item, index) {
    // console.log(item.command)
    if (item.command === 'PRIVMSG' || item.command === 'HISTORY') {
      return this.messageCell(item, index)
    } else if (item.command === 'JOIN' || item.command === 'PART' || item.command === 'QUIT' || item.command === 'NICK') {
      return this.joinCell(item, index)
    } else if (item.command === 'ACTION' || item.command === 'KICK') {
      return this.joinCell(item, index)
    }

    return null
  }

  joinCell(item, index) {
    const avatar = avatarFromString(item.nick)

    let Cell
    if (this.props.proLayoutEnabled) {
      Cell = ProGenericAction
    } else {
      Cell = ModernGenericAction
    }

    return (
      <Cell
        key={index}
        nickname={item.nick}
        color={this.getColorForString(item.nick)}
        timestamp={item.timestamp}
        text={item.messageText()}
        textAlign="center"
        avatar={avatar}
      />
    )
  }

  actionCell(item, index) {
    const avatar = avatarFromString(item.nick)
    const textAlign = item.nick === this.props.client.nickname ? 'flex-end' : 'flex-start'

    let Cell
    if (this.props.proLayoutEnabled) {
      Cell = ProGenericAction
    } else {
      Cell = ModernGenericAction
    }

    return (
      <Cell
        key={index}
        nickname={item.nick}
        color={this.getColorForString(item.nick)}
        timestamp={item.timestamp}
        text={item.messageText()}
        textAlign={textAlign}
        avatar={avatar}
      />
    )
  }

  messageCell(item, index) {
    var hideNicknameAndAvatar = false
    var indentText = false
    const alignRight = item.isMe || false

    if (index > 0) {
      const previousItem = this.props.messageList[index - 1]
      const timeSincePreviousItem = (item.timestamp.getTime() - previousItem.timestamp.getTime()) / 1000
      if (previousItem.nick === item.nick && timeSincePreviousItem < 230 && (previousItem.command === 'PRIVMSG' || previousItem.command === 'HISTORY')) {
        hideNicknameAndAvatar = true
      } else {
        indentText = true
      }
    }

    if (index === 0) {
      indentText = true
    }

    let Cell
    if (this.props.proLayoutEnabled) {
      Cell = ProMessage
    } else {
      Cell = ModernMessage
    }

    return (
      <Cell
        key={index}
        nick={item.nick}
        text={item.messageText()}
        id={item.id}
        timestamp={item.timestamp}
        hideNicknameAndAvatar={hideNicknameAndAvatar}
        indentText={indentText}
        alignRight={alignRight}
        color={this.getColorForString(item.nick)}
      />
    )
  }

  getColorForString(string) {
    if (this.colorCache[string]) {
      return this.colorCache[string]
    }

    const color = colorForString(string)
    this.colorCache[string] = color

    return color
  }

  scrollToBottom() {
    let objDiv = document.getElementById(`scrollable-chat-container-${this.props.target}`)
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight + 100
    }
  }

  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 })
  handleProgress = progress => this.setState({ progress })
  handleUploadError = error => {
    this.setState({ isUploading: false })
    console.error(error)
  }
  handleUploadSuccess = filename => {
    this.setState({ avatar: filename, progress: 100, isUploading: false })
    this.firebase
      .storage()
      .ref(this.props.client.nickname)
      .child(filename)
      .getDownloadURL()
      .then(url => this.handleImageUploadURL(url, this.props.target))
  }

  async handleImageUploadURL(url) {
    const shortenedURL = await shortenURL(url)
    const finalURL = shortenedURL.url || url
    this.props.send(`Uploaded image: ${finalURL}`, this.props.target)
  }

  normalizeText(text) {
    return text.replace(/[\r\n\v]+/g, '')
  }
}



// WEBPACK FOOTER //
// ./src/views/chat/Messages.jsx